import { z } from 'zod';
import superjson from 'superjson';
import { Selectable } from 'kysely';
import { Checkpoints } from '../../helpers/schema';

export const schema = z.object({
  checkpointId: z.string().min(1),
});

export type InputType = z.infer<typeof schema>;

// Define the structure of a file in the snapshot
export type SnapshotFile = {
  fileName: string;
  filePath: string;
  content: string;
  language: string;
};

// We extend the base Checkpoints type but override filesSnapshot to be the parsed array
export type CheckpointWithParsedFiles = Omit<Selectable<Checkpoints>, 'filesSnapshot'> & {
  filesSnapshot: SnapshotFile[];
};

export type OutputType = {
  checkpoint: CheckpointWithParsedFiles;
};

export const getCheckpointPreview = async (
  input: InputType,
  init?: RequestInit,
): Promise<OutputType> => {
  const params = new URLSearchParams({ checkpointId: input.checkpointId });
  const result = await fetch(`/_api/checkpoints/preview?${params.toString()}`, {
    method: 'GET',
    credentials: 'include',
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
